import React, { useCallback, useState } from 'react';
import { Modal } from 'antd';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import BookingOrder from '../types/BookingOrder';
import { useTranslation } from 'react-i18next';
import BookingOrderAPI from '../api/BookingOrderAPI';
import { useNavigate } from 'react-router-dom';

type DeleteBookingOrderModalProps = {
  bookingOrder?: BookingOrder;
  showModal: boolean;
  onCancel: () => void;
};

dayjs.extend(localizedFormat);

const DeleteBookingOrderModal: React.FC<DeleteBookingOrderModalProps> = ({
  bookingOrder,
  showModal,
  onCancel,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const deleteBookingOrder = useCallback(async () => {
    if (!bookingOrder) return;
    setIsSubmitting(true);
    try {
      await BookingOrderAPI.deleteBookingOrder(bookingOrder.id);
    } finally {
      setIsSubmitting(false);
      navigate('/bestallningar');
    }
  }, [bookingOrder, navigate]);

  return (
    <Modal
      centered
      title={t('components.DeleteBookingOrderModal.confirmDelete')}
      open={showModal}
      onCancel={onCancel}
      onOk={deleteBookingOrder}
      okButtonProps={{ loading: isSubmitting }}
      cancelText={t('common.no')}
      okText={t('common.yes')}>
      {t('components.DeleteBookingOrderModal.canNotUndo')}
    </Modal>
  );
};

export default DeleteBookingOrderModal;
